const modalidades = Object.freeze({
  AZUL: 'Azul',
  VERDE: 'Verde',
  BRANCA: 'Branca',
  CONVENCIONAL: 'Convencional',
})

export default modalidades
